import GoogleMap from "../../../components/map";
import SectionTitle from "../../../components/section-title";
import PropTypes from "prop-types";

const GoogleMapContainer = ({ classOption, withHeading }) => {
    if (withHeading) {
        return (
            <section className="location-area">
                <div className="container">
                    <SectionTitle classOption="text-center" subTitle="오시는 길" title="정환교피부과 <span>위치 안내</span>" />
                    <p className="location-address">경기 안산시 단원구 중앙대로 915 월드코아 5층 · 031-402-7500</p>
                    <div className={`map-area ${classOption}`}>
                        <GoogleMap />
                    </div>
                </div>
            </section>
        );
    }

    return (
        <div className={`map-area ${classOption}`}>
            <GoogleMap />
        </div>
    );
};

GoogleMapContainer.propTypes = {
    classOption: PropTypes.string,
    withHeading: PropTypes.bool,
};

GoogleMapContainer.defaultProps = {
    classOption: "map-area",
    withHeading: false,
};

export default GoogleMapContainer;
